import { API, graphqlOperation } from 'aws-amplify'

import { partnerControl as partnerControlQuery } from './queries'

// Die *Control-Resolver antworten mit AWSJSON: ein String, der nach dem Parsen
// { statusCode, headers, body: { [todo]: { res } } } enthält (partnerControl)
// oder direkt { [todo]: { res } } (integrationControl). Beides wird hier auf
// den body normalisiert.
export function parseControlResponse(raw) {
  const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
  const body = parsed?.body ?? parsed
  return typeof body === 'string' ? JSON.parse(body) : body
}

// Direkt über API.graphql statt über query() aus ./index: das injiziert
// limit/nextToken, was der Resolver nicht kennt.
export async function partnerControl({ action, ...variables }) {
  const { data } = await API.graphql(
    graphqlOperation(partnerControlQuery, { action, ...variables })
  )
  return parseControlResponse(data.partnerControl)
}

// Ergebnis des Todos, das wie die Action heißt (previewDeletePartner,
// deletePartner). Fehlt es, hat der Resolver die Action nicht ausgeführt.
export function controlResult(body, action) {
  const res = body?.[action]?.res
  if (res === undefined || res === null) {
    throw new Error(`partnerControl: keine Antwort für "${action}"`)
  }
  return res
}

export const isAuthError = (err) =>
  (err?.errors || []).some(
    (e) =>
      e.errorType === 'Unauthorized' || /nur Aivy-Admins/i.test(e.message || '')
  )
